// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3510":"4ddefb67e816dc59","9105":"d71a1e302c32e94a"}[chunkId] + ".js";
};